import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    root: {
      display: 'flex',
      flexDirection: 'column',
      fontSize: '14px',
    },

    medium: {
      width: '240px',
      height: '44px',
    },

    field: {
      boxSizing: 'border-box',
      padding: '12px 16px',
      backgroundColor: '#f4f4f4',
      borderRadius: '4px',
      border: 0,
    },

    alert: {
      color: '#ff0000',
      display: 'flex',
      position: 'absolute',
      marginTop: '50px',
      zIndex: 10,
    },
  },
  {
    name: 'VersionField',
  },
);
